


























































import { Component, Vue } from 'vue-property-decorator';

import { curPref, Preferences } from '@/services/Preferences';
import { Device } from '@/types/core';

import { DateTime } from 'luxon';
import { DevicePage, DeviceService, curDeviceService } from '@/services/DeviceService';
import { NfreshClient,curNfreshClient } from '../../services/NfreshClient';

import Loading from '@/components/Loading.vue';
import SearchBox from '@/components/SearchBox.vue';
import NfreshProbeRow from '@/components/nfresh/NfreshProbeRow.vue';
import NfreshProbeRowMobile from '@/components/nfresh/NfreshProbeRowMobile.vue';
import VueError from '@/components/VueError.vue';
import PageNav from '@/components/PageNav.vue';
import NavBar from '@/components/NavBar.vue';
import { Probe } from '../../types/nfresh';


@Component({
  components: {
    NfreshProbeRow,
    NfreshProbeRowMobile,
    SearchBox,
    VueError,
    PageNav,
    Loading,
    NavBar
  },
})
export default class NfreshProbes extends Vue {

  // our model
  dateTime = DateTime;
  curOrderBy = curPref.retrieve('v3-nfresh-probes-cur-order', 'deviceId');
  curAscDesc = curPref.retrieve('v3-nfresh-probes-cur-asc-desc', 'asc');
  searchTerm = curPref.retrieve('v3-nfresh-probes-search-term', '');
  pageSize = 20;
  error:string = '';
  httpBusy:boolean = false;
  probeList:Probe[] = [];
  
  // internal dependencies
  private nfreshClient:NfreshClient = curNfreshClient;

  async mounted() {

    this.refreshData();
  }

  async refreshData() {

    this.httpBusy = true;

    const reply = await this.nfreshClient.getProbes({skip:0, limit:1000});

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(reply.errorMsg)
      return this.error = `Unable to load devices because ${reply.errorMsg}`;

    this.probeList = reply.probeList;

  }

  newOrderBy(newOrderBy:{orderBy:string, ascDesc:string}) {
    
    curPref.store('v3-nfresh-probes-cur-order', newOrderBy.orderBy);
    curPref.store('v3-nfresh-probes-cur-asc-desc', newOrderBy.ascDesc);

    this.curOrderBy = newOrderBy.orderBy;
    this.curAscDesc = newOrderBy.ascDesc;

    this.refreshData();
  }

  newSearchText(newSearchText:string) {

    curPref.store('v3-nfresh-probes-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  get showSearchBox():boolean {
    return false;
    // return this.probeList.length > 0 || this.searchTerm !== '';
  }

  /*get showPageNav():boolean {
    return this.pageList.length > 0;
  }*/

  get showDeviceRows():boolean {
    return !this.httpBusy && this.probeList.length > 0;
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.probeList.length === 0 && this.searchTerm !== '';
  }

  get showNoProbes():boolean {
    return !this.httpBusy && this.probeList.length === 0 && this.searchTerm === '';
  }
}
